import type { IconDefinition } from '../../types'

export default {
  details: [32, 33, [], '', 'M2.05671 23.5165C1.14456 23.1463 0.705185 22.1068 1.07534 21.1946C1.16498 20.9738 1.29802 20.7731 1.46659 20.6045L9.57357 12.4975C9.69472 12.3764 9.8327 12.2733 9.98325 12.1916L29.4705 1.60784C30.408 1.09871 31.4313 2.12542 30.919 3.06116L20.2804 22.495C20.199 22.6436 20.097 22.7798 19.9772 22.8995L11.8715 31.0053C11.1754 31.7014 10.0468 31.7014 9.35075 31.0053C9.18113 30.8357 9.04749 30.6335 8.95784 30.411L6.98589 25.5168L2.05671 23.5165Z'],
  name: 'uiVesselSolid',
  oldName: 'cusVessel'
} as IconDefinition
